import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { ChargingStationType, Manufacturer } from './model';

const client = createClient('/rest/config');

export const chargingStationTypesPermissions = {
  SEARCH: 'cpms.search-charging-station-types',
  CREATE: 'cpms.create-charging-station-type',
  UPDATE: 'cpms.update-charging-station-type',
  DELETE: 'cpms.delete-charging-station-type'
};

export const manufacturersPermissions = {
  SEARCH: 'cpms.search-charging-station-type-manufacturers',
  CREATE: 'cpms.create-charging-station-type-manufacturer'
};

export const searchChargingStationTypes: SearchOperation<ChargingStationType> =
  searchRequestFactory<ChargingStationType>(client, {
    pattern: '/chargingstationtypes',
    permissionId: chargingStationTypesPermissions.SEARCH
  });

export const createChargingStationType: SaveOperation<ChargingStationType, void> = postRequestFactory<
  ChargingStationType,
  void
>(client, { pattern: '/chargingstationtypes', permissionId: chargingStationTypesPermissions.CREATE });

export const updateChargingStationType: SaveOperation<ChargingStationType, number> = putRequestFactory<
  ChargingStationType,
  number
>(client, { pattern: '/chargingstationtypes/{id}', permissionId: chargingStationTypesPermissions.UPDATE });

export const deleteChargingStationType: DeleteOperation<void> = deleteRequestFactory<void, number>(client, {
  pattern: '/chargingstationtypes/{id}',
  permissionId: chargingStationTypesPermissions.DELETE
});

export const searchManufacturers: SearchOperation<Manufacturer> = searchRequestFactory<Manufacturer>(client, {
  pattern: '/manufacturers',
  permissionId: manufacturersPermissions.SEARCH
});

export const createManufacturer: SaveOperation<Manufacturer, Manufacturer> = postRequestFactory<
  Manufacturer,
  Manufacturer
>(client, {
  pattern: '/manufacturers',
  permissionId: manufacturersPermissions.CREATE
});
